import { useHistory } from "react-router-dom";
import NavCommon from "../../components/@navHeader";
import variavel from "../../enviroments";
import * as S from "./styles";

// URL do Cadastro Cyrela por ambiente.
// Obs.: a URL de PROD ainda não está no ar, mas já fica configurada.
const CADASTRO_CYRELA_URL_BY_ENV: Record<string, string> = {
  DEV: "https://dev.cadastrocyrela.com.br/#/code",
  QA: "https://qa.cadastrocyrela.com.br/#/code",
  PROD: "https://cadastrocyrela.com.br/#/code",
};

export const getCadastroCyrelaUrl = (): string =>
  CADASTRO_CYRELA_URL_BY_ENV[variavel.AMBIENTE ?? "PROD"] ??
  CADASTRO_CYRELA_URL_BY_ENV.PROD;

const CadastroCyrela = () => {
  const history = useHistory();
  const url = getCadastroCyrelaUrl();

  const breadcrumbs = [{ path: "", name: "Onboarding" }];

  return (
    <S.Container>
      <NavCommon
        breadcrumbs={breadcrumbs}
        onBack={() => history.goBack()}
        onChangeActionNew={() => {}}
      />
      <S.Card>
        <S.Header>
          <S.Title>Onboarding</S.Title>
        </S.Header>
        <S.IframeContainer>
          <iframe
            src={url}
            frameBorder="0"
            title="Onboarding"
            allow="fullscreen"
            allowFullScreen
            style={{
              border: "none",
              width: "100%",
              height: "100%",
            }}
          />
        </S.IframeContainer>
      </S.Card>
    </S.Container>
  );
};

export default CadastroCyrela;
